import { render } from "./SuccessIcon.vue?vue&type=template&id=0e51837a"
const script = {}
script.render = render

export default script